function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8332 17.4997H5.6665V5.83301H14.8332V17.4997ZM14.8332 4.16634H5.6665C5.22448 4.16634 4.80055 4.34194 4.48799 4.6545C4.17543 4.96706 3.99984 5.39098 3.99984 5.83301V17.4997C3.99984 17.9417 4.17543 18.3656 4.48799 18.6782C4.80055 18.9907 5.22448 19.1663 5.6665 19.1663H14.8332C15.2752 19.1663 15.6991 18.9907 16.0117 18.6782C16.3242 18.3656 16.4998 17.9417 16.4998 17.4997V5.83301C16.4998 5.39098 16.3242 4.96706 16.0117 4.6545C15.6991 4.34194 15.2752 4.16634 14.8332 4.16634ZM12.3332 0.833008H2.33317C1.89114 0.833008 1.46722 1.0086 1.15466 1.32116C0.842099 1.63372 0.666504 2.05765 0.666504 2.49967V14.1663H2.33317V2.49967H12.3332V0.833008Z",
  className: "icon-primary"
});

function SvgCopyGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGreen);
export default __webpack_public_path__ + "static/media/copy-green.634ab4b3.svg";
export { ForwardRef as ReactComponent };